import { object, string } from 'yup';
import i18n from '../../../i18n';

// Types
import { VehicleManagement } from './types';

// ✅ Schema base con ownership (usage se asigna automáticamente)
export const VehicleManagementSchema = object<VehicleManagement>({
  plate: string().required(() => i18n.t('validation:required')),
  model: string().required(() => i18n.t('validation:required')),
  category: string().required(() => i18n.t('validation:required')),
  concession: string().required(() => i18n.t('validation:required')),
  ownership: string().required(() => i18n.t('validation:required')),
  usage: string().notRequired(), // ✅ Opcional: se asigna automáticamente como CONSTRUCTION
});

// ✅ Schema condicional - concesión solo para vehículos INTERNAL
export const VehicleManagementSchemaConditional = object<VehicleManagement>({
  plate: string().required(() => i18n.t('validation:required')),
  model: string().required(() => i18n.t('validation:required')),
  category: string().required(() => i18n.t('validation:required')),
  ownership: string().required(() => i18n.t('validation:required')),
  usage: string().notRequired(), // ✅ Opcional: se asigna automáticamente como CONSTRUCTION
  concession: string().when('ownership', {
    is: 'INTERNAL',
    then: (schema) => schema.required(() => i18n.t('validation:required')),
    otherwise: (schema) => schema.notRequired(),
  }),
});

// ✅ Schema sin concesión requerida
export const VehicleManagementSchemaNoConcession = object<VehicleManagement>({
  plate: string().required(() => i18n.t('validation:required')),
  model: string().required(() => i18n.t('validation:required')),
  category: string().required(() => i18n.t('validation:required')),
  ownership: string().required(() => i18n.t('validation:required')),
  usage: string().notRequired(), // ✅ Opcional: se asigna automáticamente como CONSTRUCTION
  concession: string().notRequired(),
});
